import { h, Component } from 'preact'
import { Button } from 'react-toolbox/lib/button'
import userApi from './../../api/user/user'
import { setUser } from './../../api/user/actions'
import style from './style'

class UserMenu extends Component {
  signOut = () => {
    userApi.signOut().then(() => {
      this.props.setUser(null)
    })
  }
  render({ user }, { active }) {
    return (
      <Button
        primary
        class={style.button}
        label="Sign out"
        onClick={() => {
          this.setState({ active: !active })
          this.signOut()
        }}
      />
    )
  }
}

import { connect } from 'preact-redux'

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUser: user => dispatch(setUser(user)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu)



// WEBPACK FOOTER //
// ./components/userMenu/UserMenu.js